<div class="aig-claimsState u-my-8 container u-minheight-vh-60">
  <div class="row u-justify-center">
    <div class="col-12">
      <aig-breadcrumb [config]="[
        { title: 'Área de cliente', link: '/area-cliente' },
        { title: 'Gestión de siniestros', link: '/area-cliente/gestion-siniestros' }]">
      </aig-breadcrumb>
    </div>
    <div class="col-12 col-md-6 u-mt-8">
      <section>
        <div class="u-ds-grid u-gap-40">
          <h1 class="u-color-primary1 u-fw-400 u-h1 u-text-center">
            Estado de siniestro
          </h1>
          <div class="u-radius-4 u-border u-border-comp3 u-px-8 u-py-6 u-ds-grid u-gap-16">
            <div class="row p-flexce">
              <div class="col-6 p-flexce">
                <div *ngIf="claim?.permiteDocumentacion === true; else seeDoc">
                  <button class="e-btn--primary u-gap-8 u-fw-500" type="button" (click)="OpenAddDoc()">
                    <p class="">Adjuntar documentación</p>
                    <i class="icon-eye-open u-fs-20"></i>
                  </button>
                </div>
                <ng-template #seeDoc>
                  <button class="e-btn--primary u-gap-8 u-fw-500" type="button" (click)="OpenSeeDoc()">
                    <p class="">Ver documentación</p>
                    <i class="icon-eye-open u-fs-20"></i>
                  </button>
                </ng-template>
              </div>
            </div>
            <h2 class="u-color-primary1 u-h2">
              Datos del siniestro
            </h2>
            <div class="u-fs-18 u-fw-600 u-color-secondary1 p-flexcb">
              <p class="u-fw-400">Número de siniestro</p>
               {{ claim?.numExpediente }}
            </div>
            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
              <p>Estado del expediente:</p>
              <span class="e-badge" [ngClass]="claimState(claim?.idEstadoExpediente)">
                {{ claim?.estadoExpediente }}
              </span>
            </div>
            <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
              <p>Fecha de creación</p>
              {{ claim?.fechaCreacion | date: 'd \'de\' MMMM \'de\' y' }}
            </div>
            @switch (claim?.idEstadoExpediente) {
              @case (3) {
                <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
                  <p>Fecha de cierre</p> {{ claim?.fechaCierre | date: 'd \'de\' MMMM \'de\' y' }}
                </div>
              }
              @case (4) {
                <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
                  <p>Fecha de cierre</p> {{ claim?.fechaCierre | date: 'd \'de\' MMMM \'de\' y' }}
                </div>
                <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
                  <p>Resolución</p> {{claim?.resolucion}}
                </div>
                <div class="u-fs-18 u-fw-400 u-color-secondary1 p-flexcb">
                  <p>Importe de transferencia</p>
                  {{claim?.importeTransferencia}}
                </div>
              }
            }
          </div>
        </div>
      </section>
    </div>
    <div class="p-flexcc u-mt-8">
      <p class="u-fs-18 u-fw-400 u-color-black">Recuerda que para cualquier consulta puedes escribirnos a <a
          href="mailto:backoffice.caixa@icp.es" class="u-color-selected1">
          {{ supportEmail }}
        </a></p>
    </div>
  </div>
</div>

<ng-container *ngIf="visibleVerDocumentacionModal">
  <aig-modal-documentation [idSiniestro]="claim?.idExpediente" (hideModal)="CloseSeeDoc()" ></aig-modal-documentation>
</ng-container>

<ng-container *ngIf="visibleAdjuntarDocumentacionModal">
  <aig-modal-add-documentation [idSiniestro]="claim?.idExpediente" (hideAddDocModal)="CloseAddDoc()"></aig-modal-add-documentation>
</ng-container>